export { default } from './placeholder-cell';
